import { render, staticRenderFns } from "./TopJettonPercentChange.vue?vue&type=template&id=d84c2422"
import script from "./TopJettonPercentChange.vue?vue&type=script&lang=js"
export * from "./TopJettonPercentChange.vue?vue&type=script&lang=js"
import style0 from "./TopJettonPercentChange.vue?vue&type=style&index=0&id=d84c2422&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports